const socketFacturacionCL = {
	state: {
        socketFacturacionCL: false
	},
	mutations: {
        setSocketFacturacionCLConnect(state, url) { 
        },
	},
	actions: {
	},
}

export default socketFacturacionCL